import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const comparisons = [{
  without: 'Historias clínicas en papel suelto',
  with: 'Todo digital y organizado'
}, {
  without: 'Vacunas vencidas sin saberlo',
  with: 'Alertas automáticas de vencimiento'
}, {
  without: 'Inventario que nunca cierra',
  with: 'Stock actualizado en tiempo real'
}, {
  without: 'Cada uno registra diferente',
  with: 'Sistema unificado para todo el equipo'
}, {
  without: 'Horas perdidas en admin',
  with: '10 minutos por consulta, nada más'
}];
export function Comparison() {
  return <section className="bg-white py-12 px-6" data-id="element-35">
      <div className="max-w-md mx-auto space-y-8" data-id="element-36">
        <h2 className="text-2xl font-bold text-navy text-center" data-id="element-37">
          Sin el Kit vs. Con el Kit
        </h2>

        <div className="space-y-4" data-id="element-38">
          {comparisons.map((item, index) => <div key={index} className="grid grid-cols-2 gap-3" data-id="element-39">
              <div className="bg-red-50 border border-red-200 rounded-lg p-4 space-y-2" data-id="element-40">
                <div className="flex items-center gap-2" data-id="element-41">
                  <XIcon className="w-4 h-4 text-red-500 flex-shrink-0" data-id="element-42" />
                  <span className="text-xs font-semibold text-red-700" data-id="element-43">
                    Sin Kit Veterinario Elite
                  </span>
                </div>
                <p className="text-sm text-navy/80" data-id="element-44">{item.without}</p>
              </div>

              <div className="bg-teal/5 border border-teal/30 rounded-lg p-4 space-y-2" data-id="element-45">
                <div className="flex items-center gap-2" data-id="element-46">
                  <CheckIcon className="w-4 h-4 text-teal flex-shrink-0" data-id="element-47" />
                  <span className="text-xs font-semibold text-teal" data-id="element-48">
                    Con Kit Veterinario Elite
                  </span>
                </div>
                <p className="text-sm text-navy/80" data-id="element-49">{item.with}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}